"use client";

import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const partners = [
  "./assets/bmt/Amni_official_logo.jpg",
  "./assets/bmt/LSG Logo.png",
  "./assets/bmt/chevron-logo-png_seeklogo-483869.png",
  "./assets/bmt/NNPC Logo.png",
  "./assets/bmt/Vanderbilt_University_seal.svg.png"
];

const OurSponsors = () => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <section className="relative px-[25px] mt-8 sm:mt-16 sm:mt-20 overflow-hidden bg-white">
      {/* ✅ SOFT YOUTHFUL COLOR SPLASHES */}
      <div className="absolute -top-24 left-0 w-[260px] h-[260px] bg-pink-400/20 blur-[120px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[280px] h-[280px] bg-orange-300/20 blur-[120px] rounded-full" />

      {/* ✅ TITLE */}
      <h2
        data-aos="fade-right"
        data-aos-duration="600"
        className="
          relative z-10 
          text-[36px] lg:text-[48px] 
          text-center 
          sm:text-start 
          w-full 
          leading-[1.15] 
          font-extrabold 
          text-primary_red 
          mb-4
        "
      >
        Our Partners
      </h2>

      {/* ✅ SUBTEXT */}
      <p
        data-aos="fade-right"
        data-aos-delay="150"
        className="relative z-10 text-gray-600 text-sm sm:text-base mb-12 max-w-2xl"
      >
        We are proud to be supported by organizations who share our passion for
        impact, care, and community
      </p>

      {/* ✅ YOUTHFUL LOGO GRID */}
      <div
        data-aos="fade-up"
        data-aos-duration="700"
        className="relative z-10 w-full flex justify-center lg:justify-end"
      >
        <div
          className="
            w-full lg:w-2/3 
            grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8 
            place-items-center 
            bg-gradient-to-br from-white via-[#fff1f2] to-white
            rounded-[32px] 
            p-8 sm:p-10 
            border border-pink-100 
            shadow-[0_25px_70px_rgba(255,107,129,0.15)]
          "
        >
          {partners.map((logo, index) => (
            <div
              key={index}
              className="
                group w-full h-20 
                flex items-center justify-center 
                rounded-2xl 
                bg-white 
                border border-pink-100 
                transition-all duration-300 
                hover:-translate-y-2 
                hover:rotate-[-1deg]
                hover:shadow-[0_15px_40px_rgba(255,90,120,0.25)]
              "
            >
              <img
                src={logo}
                alt="Partner Logo"
                className="
                  h-12 object-contain 
                  opacity-80 
                  transition-all duration-300 
                  group-hover:opacity-100 
                  group-hover:scale-110
                "
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurSponsors;
